import React from 'react';
import CompanyMicrosoftDefenderAstIntegration from './CompanyMicrosoftDefenderAstIntegration';
import CompanyMicrosoftDefenderAstDashboard from './CompanyMicrosoftDefenderAstDashboard';

/**
 * @param {object} props
 * @param {number} props.companyId
 * @param {'integration'|'dashboard'} [props.variant] — integration = Settings only (connect/disconnect); dashboard = main tab
 */
function CompanyMicrosoftDefenderAst({ companyId, variant = 'dashboard' }) {
    if (variant === 'integration') {
        return (
            <CompanyMicrosoftDefenderAstIntegration companyId={companyId} />
        );
    }
    return <CompanyMicrosoftDefenderAstDashboard companyId={companyId} />;
}

export default CompanyMicrosoftDefenderAst;
